import React from 'react';
import PropTypes from 'prop-types';
import ListBadge from 'components/Common/ListBadge';
import PhysicianUtils from 'services/PhysicianUtils';
import CalendarUtils from 'services/CalendarUtils';
import PatientUtils from 'services/PatientUtils';
import {useAppSelector} from "careand-redux/store";

const DATE_FORMAT = 'Do MMM YYYY h:mm A';

const AppointmentNoteBadge = ({item, showPatient, count, title, firstLine, secondLine, dateFormat = DATE_FORMAT}) => {

  const physician = useAppSelector(state => state.physicians.byId[item.author_id]);
  const patient = useAppSelector(state => state.patients.byId[item.patient_id]);

  return (
    <ListBadge
      title={title || getTitle(physician, patient, showPatient)}
      firstLine={firstLine || <span className="capitalize">{item.item_type}</span>}
      secondLine={secondLine || CalendarUtils.format(item.value.date, dateFormat)}
      count={count}
    />
  );
}

function getTitle(physician, patient, showPatient = false) {
  return showPatient ? PatientUtils.getName(patient) : PhysicianUtils.getName(physician);
}

AppointmentNoteBadge.propTypes = {
  item: PropTypes.object.isRequired,
  showPatient: PropTypes.bool
};

export default AppointmentNoteBadge;
